import React, { ReactNode } from "react";
import Layout from "./Layout";
import Navbar from "./Navbar";

type Props = {
  auth?: boolean;
  light?: boolean;
  full?: boolean;
  account?: boolean;
  children: ReactNode;
};

const AuthLayout: React.FC<Props> = ({ children }) => {
  return (
    <>
      <Navbar />
      <Layout auth>{children}</Layout>
      {/* <Footer /> */}
    </>
  );
};

export default AuthLayout;
